import React from 'react';
import type { CellRenderProps } from '@axiom/ui';
import { ProfileStatusBadge } from '@axiom/ui';

import type { CandidateDetail } from '../../api/chat-api';
import { MatchGridUtil } from '../../utils/match-grid-util';

/** A candidate's profile status as the design system's badge. */
export const MatchGridProfileStatus = ({
  data,
}: CellRenderProps<CandidateDetail>) => {
  if (!data.profileStatus) return MatchGridUtil.NOT_YET;

  return (
    <ProfileStatusBadge
      name={`PROFILE_STATUS_BADGE_${data.id}`}
      profileStatus={data.profileStatus}
    />
  );
};
